import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
// import { Company } from "./company.entity";
// import { Shop } from "./shop.entity";
// CxCompanyの代わりにClientsを用いる
// CxShopの代わりにBranchesを用いる
import { Clients  } from "./clients.entity";
import { Branches } from "./branches.entity";
import { CxQuestionHeader } from "./cx-question-header.entity";
import { Exclude } from "class-transformer";

@Entity()
export class CxBrand extends CommonColumns {

  @Column({ length: 100, })
  name: string;

  // @ManyToOne(() => Company, company => company.brands, { nullable: false, })
  // @JoinColumn({ name: 'company_id', referencedColumnName: 'id', })
  // company: Company;

  // @Column({ name: 'company_id', })
  // companyId: number;
  // CxCompanyの代わりにClientsを用いる
  @ManyToOne(() => Clients, client => client.cxBrands, { nullable: false, })
  @JoinColumn({ name: 'client_id', referencedColumnName: 'id', })
  client?: Clients;

  @Column({ name: 'client_id', })
  clientId: number;

  @Exclude()
  @Column({ name: 'common_shop_token', })
  commonShopToken: string;

  @Column("character varying", { name: "external_link_title", nullable: true })
  externalLinkTitle: string | null;

  @Column("character varying", { name: "external_link_description", nullable: true })
  externalLinkDescription: string | null;

  // @OneToMany(() => Shop, shop => shop.brand)
  // shops: Shop[];
  // CxShopの代わりにBranchesを用いる
  @OneToMany(() => Branches, branch => branch.cxBrand)
  branches: Branches[];

  @OneToMany(() => CxQuestionHeader, cxQuestionHeader => cxQuestionHeader.cxBrand)
  cxQuestionHeaders: CxQuestionHeader[];

  constructor(props: ICxBrand) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxBrand = Omit<CxBrand, 'dummy-no-such-field'>;
export interface ICxBrand extends TCxBrand {};
